import React from 'react';
import {ChampionshipSelector} from '../../../../../components/ChampionshipSelector';
import {InputLabelEditor} from '../../../../../components/InputLabelEditor';
import {Separator} from '../../../../../components/NotificationEditor/components/Separator';
import {CreateChallengeStyles} from '../styles';
import classNames from 'classnames';
import {mppChampionshipLabel} from '../utils';
import {MPPGameWeek} from '..';

type ChallengeCommonSectionProps = {
  setChampionshipId: (value: React.SetStateAction<number>) => void;
  onChange: (
    key: string,
    value:
      | string
      | number
      | boolean
      | {
          doublePoints: number;
        }
      | undefined,
  ) => void;
  gameWeeks?: MPPGameWeek[];
  championshipId: number;
  firstGameWeekNumber?: string;
  lastGameWeekNumber?: string;
  bonuses?: number;
  isPinned?: boolean;
  editedChallengeId?: boolean;
  customShortChallengeId?: string;
  isSuperPinned?: boolean;
};

const ChallengeCommonSection = ({
  championshipId,
  setChampionshipId,
  onChange,
  gameWeeks,
  firstGameWeekNumber,
  lastGameWeekNumber,
  isPinned,
  bonuses,
  customShortChallengeId,
  editedChallengeId,
}: ChallengeCommonSectionProps) => {
  return (
    <div style={CreateChallengeStyles.section}>
      {editedChallengeId ? null : (
        <div style={CreateChallengeStyles.inputContainer}>
          <InputLabelEditor
            title="Choisis le championnat sur lequel porte ton challenge"
            isRequired
          />
          <div style={CreateChallengeStyles.toggleContainer}>
            <ChampionshipSelector
              fromMpp
              championship={championshipId}
              onChange={(item: number) => setChampionshipId(item)}
            />
            <text
              style={
                CreateChallengeStyles.toggleText
              }>{`Je crée un challenge ${mppChampionshipLabel[championshipId]}`}</text>
          </div>
        </div>
      )}
      {editedChallengeId ? null : (
        <>
          <Separator />
          <div style={CreateChallengeStyles.inputContainer}>
            <InputLabelEditor title="Le CODE du challenge (à partager)" />
            <input
              value={customShortChallengeId}
              onChange={event =>
                onChange('customShortChallengeId', event.target.value)
              }></input>
          </div>
          <Separator />
          <div style={CreateChallengeStyles.inputContainer}>
            <InputLabelEditor
              title="A quelle journée débute le challenge ?"
              isRequired
            />
            <select
              style={{width: 150, margin: 16}}
              className="form-control"
              onChange={event => {
                onChange('firstGameWeekNumber', Number(event.target.value));
              }}
              value={firstGameWeekNumber}>
              {(gameWeeks || []).map(gameWeek => (
                <option value={Number(gameWeek.gameWeekNumber)}>
                  {`${gameWeek.gameWeekNumber}${gameWeek.roundType ? ` (${gameWeek.roundType})` : ''}`}
                </option>
              ))}
            </select>
          </div>
          <Separator />
          <div style={CreateChallengeStyles.inputContainer}>
            <InputLabelEditor
              title="A quelle journée prend fin le challenge ?"
              isRequired
            />
            <select
              style={{width: 150, margin: 16}}
              className="form-control"
              onChange={event =>
                onChange('lastGameWeekNumber', Number(event.target.value))
              }
              value={lastGameWeekNumber}>
              {(gameWeeks || [])
                .slice(Number(firstGameWeekNumber) - 1)
                .map(gameWeek => (
                  <option value={Number(gameWeek.gameWeekNumber)}>
                    {`${gameWeek.gameWeekNumber}${gameWeek.roundType ? ` (${gameWeek.roundType})` : ''}`}
                  </option>
                ))}
            </select>
          </div>
          <Separator />
          <div style={CreateChallengeStyles.inputContainer}>
            <InputLabelEditor title="Combien de bonus octroyés par joueur ?" />
            <select
              style={{width: 100, margin: 16}}
              className="form-control"
              onChange={event =>
                onChange('bonuses', Number(event.target.value))
              }
              value={bonuses}>
              {[...Array(10)].map((__, index) => (
                <option value={index + 1}>{index + 1}</option>
              ))}
            </select>
          </div>
          <Separator />
        </>
      )}
      <div style={CreateChallengeStyles.inputContainer}>
        <InputLabelEditor title="Le challenge est il pinned ?" />
        <div style={CreateChallengeStyles.toggleContainer}>
          <i
            style={{color: isPinned ? '#4054CC' : 'black'}}
            onClick={() => {
              onChange('isPinned', !isPinned);
            }}
            className={classNames('fa fa-2x', {
              'fa-toggle-on': isPinned,
              'fa-toggle-off': !isPinned,
            })}
          />
          <text style={CreateChallengeStyles.toggleText}>
            {isPinned
              ? "Oui, le challenge sera épinglé dans le carousel sur l'écran résultat"
              : "Non, le challenge ne sera pas épinglé dans le carousel sur l'écran résultat"}
          </text>
        </div>
      </div>
      <Separator />
    </div>
  );
};

export default ChallengeCommonSection;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/MPPCreateChallengeEditor/components/ChallengeCommonSection.tsx